import useApi from "../../api/useApi";

const useUserSettingsService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/settings',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserSettingsService::userShow: ${error?.message || JSON.stringify(error)}`)},
  )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'user/settings/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useUserSettingsService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  return {
    objectType:'user',
    userShow,
    userUpdate,
  }
}
export default useUserSettingsService